import "./index.css";
import successIcon from "assets/img/success.png";

const iconRc = {
  warning: "",
  success: successIcon,
  error: "",
  noIcon: false,
};
function selDom(el) {
  return document.querySelector(el);
}
function createMessage(icon, content = "content", isHomePage) {
  let div = document.createElement("div");
  div.className = `my_message_box ${isHomePage ? "my_home_message_box" : ""}`;
  div.innerHTML = `${
    icon
      ? `<img alt='' src=${icon} style="margin-right: 8px; height: 16px" />`
      : ""
  }<p class='fw-700'>${content}</p>`;
  return div;
}
/**
 *
 * @param {object} params
 * type 类型
 * content 内容
 * duration 多少秒后消失
 */
function message({
  type = "success",
  content,
  duration = 2.5,
  isHomePage = false,
}) {
  let el = selDom(".my_message_box");
  if (el) {
    return;
  }

  const icon = iconRc[type];
  document.body.appendChild(createMessage(icon, content, isHomePage));
  let t = setTimeout(() => {
    document.body.removeChild(selDom(".my_message_box"));
    clearTimeout(t);
  }, duration * 1000);
}
export default message;
